module.exports = __webpack_public_path__ + "img/prize3_active.1c50e4a.png";